import { render, staticRenderFns } from "./IntegrationExtraFields.vue?vue&type=template&id=3057b114&"
import script from "./IntegrationExtraFields.vue?vue&type=script&lang=js&"
export * from "./IntegrationExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports